import { Component, Input } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SelectPesquisavelComponent } from '../../../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { LookupItemStruct } from '../../../../../shared/services/structs/pessoa/lookup-item.struct';
import { EmptyStateComponent } from '../../../../../shared/components/empty-state/empty-state.component';

@Component({
  selector: 'app-produto-atributos',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    SelectPesquisavelComponent,
    EmptyStateComponent,
  ],
  templateUrl: './produto-atributos.component.html',
  styleUrl: './produto-atributos.component.css',
})
export class ProdutoAtributosComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() listaAtributo: LookupItemStruct[] = [];
  @Input() set dadosAtributosCarregados(dados: any[]) {
    if (dados) {
      this.atributos.clear();
      dados.forEach(item => this.addAtributoRow(item));
    }
  }

  constructor(private fb: FormBuilder) {}

  get atributos(): FormArray {
    return this.form.get('atributos') as FormArray;
  }

  getControl(item: any, controlName: string): FormControl {
    return item.get(controlName) as FormControl;
  }

  addAtributoRow(data?: any): void {
    const group = this.fb.group({
      idAtributo: [data?.idAtributo, Validators.required],
      valor: [data?.valor || ''],
    });
    this.atributos.push(group);
  }
  removeAtributoRow(index: number): void {
    this.atributos.removeAt(index);
  }
}
